import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../styles/eventos.css";

function Eventos() {
  const [eventos, setEventos] = useState([]);

  const prioridadeStatus = {
    aberto: 1,
    "em breve": 2,
    encerrado: 3,
    encerrada: 3,
    finalizado: 3,
    finalizada: 3,
    fechado: 3,
    fechada: 3,
  };

  const ordenarEventosPorStatus = (listaEventos = []) => {
    return [...listaEventos]
      .filter((evento) => evento.status !== "ocultado")
      .sort((a, b) => {
        const statusA = String(a.status || "").toLowerCase().trim();
        const statusB = String(b.status || "").toLowerCase().trim();

        const prioridadeA = prioridadeStatus[statusA] || 4;
        const prioridadeB = prioridadeStatus[statusB] || 4;

        if (prioridadeA !== prioridadeB) {
          return prioridadeA - prioridadeB;
        }

        if (statusA === "aberto") {
          return new Date(a.dataFim) - new Date(b.dataFim);
        }

        if (statusA === "em breve") {
          return new Date(a.dataInicio) - new Date(b.dataInicio);
        }

        return new Date(b.dataFim) - new Date(a.dataFim);
      });
  };

  useEffect(() => {
    axios.get("https://api.ticketdovaqueiro.com/api/events")
      .then(response => setEventos(ordenarEventosPorStatus(response.data)))
      .catch(error => console.error("Erro ao buscar eventos:", error));
  }, []);

  const calcularTempoRestante = (dataFim) => {
    const agora = new Date();
    const encerramento = new Date(dataFim);
    const diferenca = encerramento - agora;

    if (diferenca <= 0) return { status: "encerrado", tempo: "Vendas Encerradas" };

    const dias = Math.floor(diferenca / (1000 * 60 * 60 * 24));
    const horas = Math.floor((diferenca / (1000 * 60 * 60)) % 24);
    const minutos = Math.floor((diferenca / (1000 * 60)) % 60);
    const segundos = Math.floor((diferenca / 1000) % 60);

    return {
      status: "ativo",
      tempo: `${dias}d ${horas}h ${minutos}m ${segundos}s`
    };
  };

  return (
    <div className="container">
      <h2>Eventos Disponíveis</h2>
      <div className="event-gridprincipal">
        {eventos.map(evento => {
          const { status, tempo } = calcularTempoRestante(evento.dataFim);
          return (
            <div key={evento._id} className="event-cardprincipal">
              <img src={`https://api.ticketdovaqueiro.com/uploads/${evento.imagem}`} alt={evento.nome} className="cartaz-evento2" />
              <h3>{evento.nome}</h3>
              <p>{evento.descricao}</p>
              
              <div className="contador-evento">
                <span>ENCERRAMENTO DAS VENDAS</span>
                <div className={`timer ${status === "encerrado" ? "encerrado" : ""}`}>
                  {tempo}
                </div>
              </div>

              {status === "ativo" ? (
                <Link to={`/evento/${evento._id}`} className="button">Ver Detalhes</Link>
              ) : (
                <button className="botao-encerrado" disabled>Vendas Encerradas</button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Eventos;
